import React, { useCallback } from 'react';
import { Box, TextV2 } from '@withjoy/joykit';
import { EventRSVPAttendanceStatus } from '@graphql/generated';
import { useTranslation } from '@shared/core';
import { performFullPageRedirect } from '@shared/utils/navigation';
import { ActionButton } from './ActionButton';
import { useAttendanceStatusConfig } from './attendanceStatusConfig';
import { FixedActionButtonContainer } from './FixedActionButtonContainer';

type GuestGuideTriggerProps = Readonly<{
  rsvpAttendanceStatus?: EventRSVPAttendanceStatus;
  eventHandle?: string;
}>;

export const GuestGuideTrigger = React.forwardRef<HTMLButtonElement, GuestGuideTriggerProps>(({ rsvpAttendanceStatus, eventHandle, ...props }, ref) => {
  const { tq } = useTranslation('guestGuide');
  const statusConfig = useAttendanceStatusConfig(rsvpAttendanceStatus, 'black');

  const handleStatusClick = useCallback(
    (e: React.MouseEvent) => {
      e.stopPropagation();
      if (eventHandle) {
        performFullPageRedirect(`/${eventHandle}/rsvp`);
      }
    },
    [eventHandle],
  );

  return (
    <FixedActionButtonContainer
      ref={ref}
      {...props}
    >
      {statusConfig && (
        <Box
          as="button"
          onClick={handleStatusClick}
          style={{ cursor: 'pointer', background: 'none', border: 'none', padding: 0 }}
        >
          <TextV2
            typographyVariant="button1"
            color="mono15"
            whiteSpace="nowrap"
          >
            {statusConfig.label}
          </TextV2>
        </Box>
      )}
      <ActionButton>{tq`View Guest Guide`}</ActionButton>
    </FixedActionButtonContainer>
  );
});

GuestGuideTrigger.displayName = 'GuestGuideTrigger';
